export enum DateTimeCompareEnum {
    LeftIsLess = -1,
    RightIsLess = 1,
    Equal = 0,
}
